import { render } from "./LeftNavigationLink.vue?vue&type=template&id=84c40d28&scoped=true"
import script from "./LeftNavigationLink.vue?vue&type=script&lang=js"
export * from "./LeftNavigationLink.vue?vue&type=script&lang=js"

import "./LeftNavigationLink.vue?vue&type=style&index=0&id=84c40d28&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c40d28"]])

export default __exports__